import ministryService from "../../../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    loading: false,
    loadingStrating : false , 
    Transaction: {},
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    loadingStrating(state) {
      return state.loadingStrating;
    },
    Transaction(state) {
      return state.Transaction;
    },
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setLoadingStrating(state, payload) {
      console.log("state.Transaction ", state.loadingStrating)
      state.loadingStrating = payload;
    },
    setData(state, payload) {
      state.Transaction = payload;
    },
  },
  actions: {
    async fetchTransactionById({ commit }, params) {
      commit("setLoading", true);
      try {
        const data = await ministryService.fetchTransactionById(params);
        if (hasError(data.status)) {
          throw res.status;
        }
        commit("setData", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    
    async changeCurrentStage({ commit }, params) {
      commit("setLoading", true);
      try {
        const data = await ministryService.changeCurrentStage(params);
        if (hasError(data.status)) {
          throw res.status;
        }
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async startChecking({ commit }, params) {
      console.log("params" , params)
      commit("setLoadingStrating", true);
      try {
        const data = await ministryService.startChecking(params);
        if (hasError(data.status)) {
          
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setLoadingStrating", false);
      }
    },
    async reAssignmentTransaction({ commit }, params) {
      commit("setLoadingStrating", true);
      try {
        const data = await ministryService.reAssignmentTransaction(params);
        if (hasError(data.status)) {
          
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setLoadingStrating", false);
      }
    },

   
    handleResponse({ commit, dispatch }, res) {
      if(res.hasOwnProperty('status'))
      {
        if (res.status > 399 && res.status <= 500) {
          this._vm.$toast({
            component: ToastificationContent,
            props: {
              title: "حدث خطأ أثناء تنفيذ العملية",
              icon: "AlertCircleIcon",
              variant: "danger",
            },
          });
          throw res.status;
        } else {
          this._vm.$toast({
            component: ToastificationContent,
            props: {
              title: "تمت العملية بنجاح",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }
      }
    },
  },
};
